import { useMemo } from "react";
import Select from "@/components/ui/design-system/Select";
import { type Library } from "@/utils/types";
import { LibrarySubGroupView } from "./LibrarySubGroupView";

type LibraryRootProps = {
  baseUrl?: Library["baseUrl"];
  libraryGroups?: Library["library"];
  pinnedGroupKey?: string;
  onGroupPathChange: (templateGroup: string[]) => unknown;
};

export function LibraryRoot({
  baseUrl,
  libraryGroups,
  pinnedGroupKey,
  onGroupPathChange,
}: LibraryRootProps) {
  const groupSelectOptions = useMemo(() => {
    if (!libraryGroups) return;

    // build a select option for each group in the set and save them in this array
    const groupKeys = Object.keys(libraryGroups);
    return groupKeys.map((groupKey) => ({ value: groupKey, label: groupKey }));
  }, [libraryGroups]);

  return (
    <div className="space-y-ds-8">
      <div className="flex items-start justify-start space-x-ds-4">
        {groupSelectOptions && (
          <Select
            placeholder="Use Case"
            buttonClassName="font-normal max-h-[32px] min-w-[240px]"
            options={groupSelectOptions}
            onChange={(group) => onGroupPathChange([group])}
          />
        )}
      </div>
      {!(libraryGroups && baseUrl) ? (
        <LibrarySubGroupView.Loading />
      ) : (
        <>
          {pinnedGroupKey && libraryGroups[pinnedGroupKey] && (
            <LibrarySubGroupView
              key={pinnedGroupKey}
              title={pinnedGroupKey}
              baseUrl={baseUrl}
              librarySubGroup={libraryGroups[pinnedGroupKey]}
              onGroupClick={(subGroup: string) =>
                onGroupPathChange([pinnedGroupKey, subGroup])
              }
            />
          )}
          {Object.entries(libraryGroups).map(([groupKey, group]) =>
            groupKey === pinnedGroupKey ? null : (
              <LibrarySubGroupView
                key={groupKey}
                title={groupKey}
                baseUrl={baseUrl}
                librarySubGroup={group}
                onGroupClick={(subGroup: string) =>
                  onGroupPathChange([groupKey, subGroup])
                }
              />
            )
          )}
        </>
      )}
    </div>
  );
}
